import script from "./BrandLogoIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandLogoIcon.vue?vue&type=script&setup=true&lang=js"

import "./BrandLogoIcon.vue?vue&type=style&index=0&id=3b0d5265&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0d5265"]])

export default __exports__